const verticalTimelineSmall = () => {
    const timelineContainers = document.querySelectorAll('[data-timeline-small]')
    if (!timelineContainers.length) return

    timelineContainers.forEach((timelineContainer) => {
        initializeTimeline(timelineContainer)
    })
}

const initializeTimeline = (timelineContainer) => {
    const timelineItems = timelineContainer.querySelectorAll('[data-timeline-small-item]')
    const sidebarButtons = timelineContainer.querySelectorAll('[data-timeline-year]')
    const prevButton = timelineContainer.querySelector('[data-timeline-nav="prev"]')
    const nextButton = timelineContainer.querySelector('[data-timeline-nav="next"]')
    
    if (!timelineItems.length || !sidebarButtons.length) return

    let currentIndex = 0

    if (window.innerWidth >= 1024) {
        timelineItems.forEach((item, index) => {
            if (index !== 0) {
                item.style.display = 'none'
            }
        })
    }

    if (sidebarButtons.length > 0) {
        sidebarButtons[0].classList.add('active')
    }

    const showItem = (index) => {
        if (window.innerWidth >= 1024) {
            timelineItems.forEach(item => {
                item.style.display = 'none'
            })
            
            if (timelineItems[index]) {
                timelineItems[index].style.display = 'block'
            }
        }
        
        sidebarButtons.forEach(btn => {
            btn.classList.remove('active')
        })
        
        if (sidebarButtons[index]) {
            sidebarButtons[index].classList.add('active')
        }
        
        currentIndex = index
        updateNavigationButtons()
    }

    const updateNavigationButtons = () => {
        if (prevButton) {
            prevButton.disabled = currentIndex === 0
            prevButton.classList.toggle('opacity-50', currentIndex === 0)
        }
        if (nextButton) {
            nextButton.disabled = currentIndex === timelineItems.length - 1
            nextButton.classList.toggle('opacity-50', currentIndex === timelineItems.length - 1)
        }
    }

    if (prevButton) {
        prevButton.addEventListener('click', () => {
            if (currentIndex > 0) {
                showItem(currentIndex - 1)
            }
        })
    }

    if (nextButton) {
        nextButton.addEventListener('click', () => {
            if (currentIndex < timelineItems.length - 1) {
                showItem(currentIndex + 1)
            }
        })
    }

    sidebarButtons.forEach((button, buttonIndex) => {
        button.addEventListener('click', () => {
            showItem(buttonIndex)
        })
    })

    updateNavigationButtons()
}

export default verticalTimelineSmall
